// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';
import {
  IDynamicBindableValue,
  IDynamicItem,
  IDynamicItemValue,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { clearBasketNotification } from '@epicuro-next/state/basket-state';

import { eventHandlerFromAction } from '../../../utils/eventhandler-from-action';
import {
  openConfigStripEventHandler,
  recommendationItemClickedEventHandler,
} from '../../events';
import { hasError, isLoading } from '../../loading-state-wrapper-helpers';
import {
  hasData,
  hasNoItems,
  httpBodyToProductData,
  productData,
  RecommendedProductDataType,
} from '../../product-data';
import { getServingConfigProperty } from '../../serving-config';

import { BestPerformingArticlesPayloadPropertiesType } from './best-performing-articles/best-performing-articles-helpers';
import {
  backgroundMedia,
  errorMessageItem,
  getIsDoneLoadingWrapper,
  getIsLoadingWrapper,
  getItemMediaPreview,
  getItemsArrayRenderer,
  getSearchBarPanelSubTitle,
  getSearchBarPanelTitle,
  noItemsItem,
} from './search-bar-helper';

export const panelName = 'SearchBarPanel';

const panelNameProvider: IDynamicBindableValue = {
  provider: 'id:root',
  property: 'panelName',
};
const panelStyleProvider: IDynamicBindableValue = {
  provider: 'id:root',
  property: 'panelTrackingId',
};

const isLoadingWrapper = getIsLoadingWrapper();

const itemMediaPreview = getItemMediaPreview(
  panelNameProvider,
  panelStyleProvider,
  {
    classes: ['marketing-panel__item'],
    style: {
      'border-radius': 'var(--border-radius-lg, .25rem)',
    },
  },
  [
    recommendationItemClickedEventHandler(
      panelNameProvider,
      panelStyleProvider,
      { provider: 'self', property: 'productData' },
    ),
    openConfigStripEventHandler('self'),
    eventHandlerFromAction(clearBasketNotification),
  ],
);

const itemsArrayRenderer = getItemsArrayRenderer(itemMediaPreview);

const panelTitle = getSearchBarPanelTitle('panel-title-content', {
  provider: 'parent',
  property: 'panelTitle',
});

const productName = getSearchBarPanelSubTitle('product-name-content', {
  provider: 'parent',
  property: 'productName',
});

const doneLoadingWrapperChildren = [
  panelTitle,
  productName,
  backgroundMedia,
  itemsArrayRenderer,
  errorMessageItem,
  noItemsItem,
];

const isDoneLoadingWrapper = getIsDoneLoadingWrapper(
  doneLoadingWrapperChildren,
);

export function createApiRequestPayloadPropertiesProvider(): IDynamicItemValue {
  return {
    values: [
      {
        provider: 'GlobalStoreProviderService',
        property: {
          path: 'accounts.activeAccount.brandOrganisations',
        },
        filter: function (brandOrganisations: [] | null | undefined): boolean {
          const hasBrandOrganisations =
            !!brandOrganisations && brandOrganisations.length > 0;
          return hasBrandOrganisations;
        }.toString(),
      },
      90,
      0,
      false,
    ],
    transform: function ([
      brandOrganisations,
      datePeriodDays,
      orderType,
      filterMissingImages,
    ]: [{ brandOrganisationId: string }[], number, number, boolean]) {
      const payloadProperties: BestPerformingArticlesPayloadPropertiesType = {
        brandOrg: brandOrganisations[0].brandOrganisationId,
        datePeriodDays,
        orderType,
        filterMissingImages,
      };

      return payloadProperties;
    }.toString(),
  };
}

export function getLoadingStateWrapper(
  panelNameProviderArg: IDynamicBindableValue,
) {
  return {
    provider: 'HttpBodyProvider',
    property: {
      values: [
        panelNameProviderArg,
        createApiRequestPayloadPropertiesProvider(),
      ],
      transform: function ([panelTypeName, apiRequestPayloadProperties]: [
        string,
        { [key: string]: unknown },
      ]) {
        const body = {
          panelType: panelTypeName,
          properties: {
            ...apiRequestPayloadProperties,
          },
        };

        const url = '/api/v2/recommendation/suggest';
        const method = 'POST';
        const fetchString =
          window.neoclesDynamicFramework.recommendationsPanels.methods.createHttpRequestFetchString(
            url,
            method,
            body,
          );

        return fetchString;
      }.toString(),
    },
    wrapWithLoadingState: true,
    transform: httpBodyToProductData.toString(),
  };
}

export const panelStyleConstants = {
  page: 'cs',
  location: 'nt',
  type: '3',
  provider: 'gcrv',
  cssVariant: '001',
};

export const searchBarPanel: IDynamicItem = {
  id: 'root',
  contentTypeId: 'dynamic-collections-renderer',
  data: {
    panelName,
    loadingStateWrapper: getLoadingStateWrapper(panelNameProvider),
    isLoading: isLoading(),
    productData: productData(),
    productName: {
      provider: 'self',
      property: 'productData',
      transform: function (data: RecommendedProductDataType[]) {
        return (
          // tslint:disable-next-line:no-any
          (data[0].product as any).masterProductTitle ??
          // tslint:disable-next-line:no-any
          (data[0].product as any).masterProduct?.title
        );
      }.toString(),
    },
    panelTitle: recommendationsPanelsLocaleKeys.bestPerforming,
    hasError: hasError(),
    hasData: hasData('self'),
    hasNoItems: hasNoItems(),
    ...getServingConfigProperty(),
    panelTrackingId: 'SQASD1',
  },
  children: [
    {
      id: 'row-wrapper',
      contentTypeId: 'dynamic-collections-renderer',
      children: [
        isLoadingWrapper,
        {
          id: 'col-wrapper',
          contentTypeId: 'dynamic-collections-renderer',
          children: [isDoneLoadingWrapper],
        },
      ],
    },
  ],
};
